import { FETCH_PENDING_PROJECT_COUNTS } from "../../store/utils/routes";
import { makeBackendGetCallWithJsonResponse } from "../../store/utils/fetch";
import { promiseEngineEarsHandler } from "../helpers";
import { FetchPendingProjectCountsResponse } from "./types";

export const fetchPendingProjectCounts = async () => {
  return makeBackendGetCallWithJsonResponse<FetchPendingProjectCountsResponse>(
    FETCH_PENDING_PROJECT_COUNTS,
    "",
  ).then(promiseEngineEarsHandler);
};
